import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M16.5 3h-5c-.276 0-.5.224-.5.5s.224.5.5.5h3.833l-8.186 8.146a.4994.4994 0 0 0-.001.707.5.5 0 0 0 .707.001L16 4.747V8.5c0 .276.224.5.5.5s.5-.224.5-.5v-5c0-.276-.224-.5-.5-.5zm-3 15h-10c-.827 0-1.5-.673-1.5-1.5v-10C2 5.673 2.673 5 3.5 5h6c.276 0 .5.224.5.5s-.224.5-.5.5h-6c-.276 0-.5.224-.5.5v10c0 .276.224.5.5.5h10c.276 0 .5-.224.5-.5v-6c0-.276.224-.5.5-.5s.5.224.5.5v6c0 .827-.673 1.5-1.5 1.5z',
  ],
  height: 20,
  width: 20,
});
